<template>
  <div class="marquee"><p class="marquee_text"><span>{{ marqueeText }}</span></p></div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Marquee',
  props: {
    text: String
  },
  computed: {
    ...mapState([
      'siteData'
    ]),
    marqueeText () {
      return this.siteData.home.header.marquee
    }
  },
  mounted () {
    let initTime = null;
    const $this = this;
    const $marqueeText = this.$el.querySelector('span')
    const textWidth = $marqueeText.clientWidth
    const fsize = window.getComputedStyle($marqueeText).fontSize.slice(0,-2);
    let posLeft = 0
    const wordPerSecond = 30 * fsize / 1000;
    function marquee(timeStamp){
      if (initTime != Math.floor(timeStamp * wordPerSecond)) {
        const wrapWidth = $this.$el.clientWidth
        const innerWidth = $marqueeText.clientWidth
        if (wrapWidth / 2 < innerWidth) {
          posLeft = posLeft - 1;
          $marqueeText.style.left = `${posLeft}px`;
          if (posLeft < -(textWidth + 50)) {
            posLeft = wrapWidth;
          }
        } else {
          $marqueeText.style.left = `${(wrapWidth - innerWidth) / 2}px`
        }
      }
      initTime = Math.floor(timeStamp * wordPerSecond);
      window.requestAnimationFrame(marquee);
    }
    window.requestAnimationFrame(marquee);
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.marquee {
  .marquee_text {
    span {
      position: relative;
      padding: 0;
      animation: none;
    }
  }
}
</style>
